var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.012C0 8.972 8.977 0 20 0s20 8.973 20 20.012C40 31.027 31.023 40 20 40S0 31.027 0 20.012Zm27.336 2.024c.212-.213.483-.54.54-.618.31-.405.464-.907.464-1.406 0-.562-.174-1.083-.502-1.507-.027-.027-.08-.085-.148-.16-.129-.14-.313-.34-.49-.516-1.582-1.698-5.713-4.476-7.876-5.325-.328-.133-1.158-.425-1.602-.444-.425 0-.83.096-1.216.29-.483.27-.869.694-1.081 1.196-.135.347-.348 1.389-.348 1.408-.212 1.139-.328 2.991-.328 5.036 0 1.951.116 3.724.29 4.882.004.005.021.088.047.216.078.391.242 1.206.416 1.54a2.43 2.43 0 0 0 2.143 1.312h.077c.58-.02 1.795-.52 1.795-.54 2.047-.85 6.082-3.493 7.703-5.248l.116-.116Z",
    fill: "#fff"
  })));
};
export default SvgPlay;